import logo from "../../assets/logo.svg";

interface LoadingOverlayProps {
	progressValue: number; // 0 - 100
}

const LoadingOverlay = ({ progressValue }: LoadingOverlayProps) => {
	return (
		<div className="fixed inset-0 z-50 flex flex-col items-center justify-center">
			<div className="text-center w-11/12 md:w-1/3">
				<img
					src={logo}
					alt="Loading..."
					className="mx-auto mb-4 w-full h-auto animate-bounce"
				/>
				<p className="text-lg mb-4">Carregando...</p>
				<div className="w-full bg-primary bg-opacity-10 rounded-full h-5">
					<div
						className="bg-primary h-5 rounded-full"
						style={{ width: `${progressValue}%` }}
					/>
				</div>
			</div>
		</div>
	);
};

export default LoadingOverlay;
